import React, { useEffect, useMemo, useState } from "react";
import { Images } from '../../../../../../../utils/imageConstants';

const GROUPS: PointsTableGroup = {
  "Group 1": [
    { home: "India", away: "England", time: "SUNDAY, 15 May 2025, 11.30 AM" },
    { home: "Bengal Tigers", away: "Lions of England", time: "SUNDAY, 15 May 2025, 11.30 AM" },
    { home: "Mumbai Warriors", away: "English Eagles", time: "SUNDAY, 15 May 2025, 11.30 AM" },
    { home: "Delhi Dynamos", away: "Southern Stars", time: "SUNDAY, 15 May 2025, 11.30 AM" },
    { home: "Kolkata Knights", away: "British Bulldogs", time: "SUNDAY, 15 May 2025, 11.30 AM" }
  ],
  "Group 2": [
    { home: "India", away: "England", time: "SUNDAY, 15 May 2025, 11.30 AM" },
    { home: "Bengal Tigers", away: "Lions of England", time: "SUNDAY, 15 May 2025, 11.30 AM" },
    { home: "Mumbai Warriors", away: "English Eagles", time: "SUNDAY, 15 May 2025, 11.30 AM" },
    { home: "Delhi Dynamos", away: "Southern Stars", time: "SUNDAY, 15 May 2025, 11.30 AM" },
    { home: "Kolkata Knights", away: "British Bulldogs", time: "SUNDAY, 15 May 2025, 11.30 AM" }
  ]
};

const getTeamFlag = (team: string): string => {
  const name = team.toLowerCase();
  if (name.includes("india")) return "🇮🇳";
  if (name.includes("england") || name.includes("british")) return "🇬🇧";
  if (name.includes("bengal") || name.includes("kolkata") || name.includes("mumbai") || name.includes("delhi")) return "🇮🇳";
  if (name.includes("english")) return "🇬🇧";
  if (name.includes("southern")) return "⭐";
  if (name.includes("lions")) return "🦁";
  if (name.includes("eagles")) return "🦅";
  if (name.includes("knights")) return "♞";
  if (name.includes("dynamos")) return "⚡";
  return "🏳️";
};

interface PointsTableProps {
  isOpen?: boolean;
  onClose?: () => void;
  onDisplay?: () => void;
}

const PointsTable: React.FC<PointsTableProps> = ({ 
  isOpen = true, 
  onClose = () => {}, 
  onDisplay = () => {} 
}) => {
  const [activeGroup, setActiveGroup] = useState("Group 1");
  const groupTabs = useMemo(() => Object.keys(GROUPS), []);

  useEffect(() => {
    const handleEscape = (event: KeyboardEvent) => {
      if (event.key === "Escape") {
        onClose();
      }
    };
    
    document.addEventListener("keydown", handleEscape);
    return () => document.removeEventListener("keydown", handleEscape);
  }, [onClose]);

  if (!isOpen) return null;

  return (
    <div className="points-modal" role="dialog" aria-modal="true">
      <div className="points-modal-backdrop" onClick={onClose} />
      <div className="points-modal-panel">
        <header className="points-modal-header">
          <nav className="points-modal-tabs" aria-label="Groups">
            {groupTabs.map((groupName) => (
              <button
                key={groupName}
                className={`points-modal-tab ${activeGroup === groupName ? "is-active" : ""}`}
                onClick={() => setActiveGroup(groupName)}
                type="button"
                aria-selected={activeGroup === groupName}
              >
                {groupName.toUpperCase()}
              </button>
            ))}
          </nav>
        </header>

        <section className="points-modal-body">
          <ul className="fixture-list" role="list">
            {GROUPS[activeGroup].map((fixture, index) => (
              <li key={`${fixture.home}-${fixture.away}-${index}`} className="fixture">
                <div className="fixture-teams">
                  <span className="fixture-team">
                    <span className="fixture-flag">
                      <img src={Images.india_flag_icon} alt={`${fixture.home} flag`} />
                    </span>
                    <span className="fixture-name">{fixture.home}</span>
                  </span>
                  <span className="fixture-vs">vs</span>
                  <span className="fixture-team-away">
                    <span className="fixture-name">{fixture.away}</span>
                    <span className="fixture-flag" role="img" aria-label={`${fixture.away} flag`}>
                      {getTeamFlag(fixture.away)}
                    </span>
                  </span>
                  <img src={Images.emgland_plus_icon} alt="England team icon" />
                </div>
                <div className="fixture-time">{fixture.time}</div>
              </li>
            ))}
          </ul>
        </section>

        <footer className="points-modal-footer">
          <button 
            className="btn btn-ghost" 
            type="button" 
            onClick={onClose}
            aria-label="Close points table"
          >
            Close
          </button>
          <button 
            className="btn btn-primary" 
            type="button" 
            onClick={onDisplay}
            aria-label="Display points table"
          >
            Display
          </button>
        </footer>
      </div>
    </div>
  );
};

export default PointsTable;
